import React from 'react';
export function TrialResults() {
  const results = [{
    outcome: 'IBS Severity Score (IBS-SSS)',
    result: 'significant reduction',
    pValue: 'p<0.001'
  }, {
    outcome: 'Hamilton Anxiety Scale (HAM-A)',
    result: 'significant reduction',
    pValue: 'p<0.001'
  }, {
    outcome: 'Hamilton Depression Scale (HAM-D)',
    result: 'significant reduction',
    pValue: 'p<0.001'
  }, {
    outcome: 'IBS Quality of Life (IBS-QoL)',
    result: 'significant improvement',
    pValue: 'p<0.001'
  }, {
    outcome: 'Abdominal pain frequency and severity',
    result: 'significantly reduced',
    pValue: 'p<0.001'
  }, {
    outcome: 'Bowel movement frequency',
    result: 'significantly improved',
    pValue: 'p<0.001'
  }];
  return <div className="bg-white rounded-2xl shadow-sm border border-taupe/30 overflow-hidden my-10" data-id="element-257">
      <div className="bg-forest px-6 py-4" data-id="element-258">
        <h3 className="text-white font-serif font-medium text-lg m-0" data-id="element-259">
          Clinical Trial Results — American Journal of Gastroenterology,
          December 2024
        </h3>
      </div>
      <div className="p-6 sm:p-8" data-id="element-260">
        <p className="text-ink/80 mb-6" data-id="element-261">
          After four weeks of transcutaneous vagus nerve stimulation (tVNS),
          patients showed statistically significant improvement across every
          measured outcome:
        </p>

        <ul className="space-y-4 mb-8" data-id="element-262">
          {results.map((item, idx) => <li key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-taupe/20 last:border-0" data-id="element-263">
              <span className="font-medium text-forest mb-1 sm:mb-0" data-id="element-264">
                {item.outcome}
              </span>
              <div className="flex items-center gap-3" data-id="element-265">
                <span className="text-ink/70 text-sm" data-id="element-266">{item.result}</span>
                <span className="inline-block bg-sage/10 text-sage text-xs font-mono px-2 py-1 rounded" data-id="element-267">
                  {item.pValue}
                </span>
              </div>
            </li>)}
        </ul>

        <p className="text-ink/80 font-medium mb-6" data-id="element-268">
          Every single outcome. At the highest level of statistical
          significance. From a non-invasive wearable device used at home, once
          daily.
        </p>

        <div className="text-xs text-ink/50 font-mono bg-beige/30 p-3 rounded-lg break-words" data-id="element-269">
          Liu J et al. American Journal of Gastroenterology. December 17, 2024.
          120(9):2139–2153. doi:10.14309/ajg.0000000000003257
        </div>
      </div>
    </div>;
}